import { render, staticRenderFns } from "./HeaderTabs.vue?vue&type=template&id=2c2ec210"
import script from "./HeaderTabs.vue?vue&type=script&lang=js"
export * from "./HeaderTabs.vue?vue&type=script&lang=js"
import style0 from "./HeaderTabs.vue?vue&type=style&index=0&id=2c2ec210&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports